webpackJsonp([1],Array(28).concat([
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_TopNav__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_MobileMenu__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hero__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SectionPolicy__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SectionFeatures__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_SectionConsulting__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_SectionFooter__ = __webpack_require__(157);
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      menu: [{
        name: 'Adquirir Póliza',
        href: '#poliza'
      }, {
        name: 'Características',
        href: '#features'
      }, {
        name: 'Contáctenos',
        href: '#contact'
      }]
    };
  },

  name: 'App',
  components: {
    'top-nav': __WEBPACK_IMPORTED_MODULE_0__components_TopNav__["a" /* default */],
    'mobile-menu': __WEBPACK_IMPORTED_MODULE_1__components_MobileMenu__["a" /* default */],
    'hero': __WEBPACK_IMPORTED_MODULE_2__components_Hero__["a" /* default */],
    'policy': __WEBPACK_IMPORTED_MODULE_3__components_SectionPolicy__["a" /* default */],
    'consulting': __WEBPACK_IMPORTED_MODULE_5__components_SectionConsulting__["a" /* default */],
    'features': __WEBPACK_IMPORTED_MODULE_4__components_SectionFeatures__["a" /* default */],
    'ic-footer': __WEBPACK_IMPORTED_MODULE_6__components_SectionFooter__["a" /* default */]
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['menu']
});

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['menu']
});

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hero_vue__ = __webpack_require__(32);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c77e489_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hero_vue__ = __webpack_require__(91);
function injectStyle (ssrContext) {
  __webpack_require__(73)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Hero_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c77e489_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Hero_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getImgUrl: function getImgUrl(img) {
      return __webpack_require__(33)("./" + img);
    }
  }
});

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./airport.jpg": 74,
	"./airport2.jpg": 75,
	"./bhmap.png": 76,
	"./blockchain.png": 77,
	"./blockchain2.png": 78,
	"./dam3.jpg": 79,
	"./fibco.png": 80,
	"./logo.png": 81,
	"./plane.jpg": 82,
	"./plane2.jpg": 83,
	"./plane3.jpg": 84,
	"./plane3.png": 85,
	"./plane4.jpg": 86,
	"./plane5.jpg": 87,
	"./plane6.jpeg": 88,
	"./plane7.jpg": 89,
	"./soilunits.png": 90
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33;

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_PostsService__ = __webpack_require__(56);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  $_veeValidate: {
    validator: 'new'
  },
  name: 'posts',
  data: function data() {
    return {
      name: '',
      number: '',
      numberpay: '',
      valid: true,
      numberpayRules: [function (v) {
        return !!v || 'El valor a pagar es requerido';
      }, function (v) {
        return v && v <= 200000 || 'El valor a pagar máximo es $200.000';
      }],
      url: '',
      date: '',
      today: new Date().toISOString().substr(0, 10),
      dialog: false,
      dialog2: false,
      modal: false,
      info: null,
      posts: [],
      length: 0,
      loading: true,
      errored: false,
      checkbox: null,
      dictionary: {
        attributes: {
          date: 'Fecha de salida'
          // custom attributes
        },
        custom: {
          name: {
            required: function required() {
              return 'El código de aerolínea no puede estar vacío';
            }
            // custom messages
          },
          number: {
            required: function required() {
              return 'El número de vuelo no puede estar vacío';
            }
          },
          date: {
            required: function required() {
              return 'La fecha de salida no puede estar vacía';
            }
          },
          checkbox: {
            required: function required() {
              return 'Debes aceptar que tienes el tiquete';
            }
          }

        }
      },
      headers: [{
        text: 'Demora en minutos',
        align: 'center',
        sortable: false,
        value: 'time'
      }, {
        text: 'Pago',
        align: 'center',
        sortable: false,
        value: 'pay'
      }],
      items: [{ text: '$10.000', value: 10000 }, { text: '$20.000', value: 20000 }, { text: '$50.000', value: 50000 }, { text: '$100.000', value: 100000 }, { text: '$150.000', value: 150000 }]
    };
  },

  mounted: function mounted() {
    this.$validator.localize('es', this.dictionary), this.getPosts();
  },


  methods: {
    submit: function submit() {
      var _this = this;

      var year = this.date.split('-')[0];
      var month = this.date.split('-')[1];
      var day = this.date.split('-')[2];

      this.$validator.validateAll().then(function (result) {
        if (result) {
          _this.dialog = true;
        }
      });
      this.url = 'https://powerful-shore-20248.herokuapp.com/https://api.flightstats.com/flex/schedules/rest/v1/json/flight/' + this.name + '/' + this.number + '/departing/' + year + '/' + month + '/' + day + '?appId=1c607d2f&appKey=c4ae8d4c325dc9871438aa2dd0967606';
      __WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(this.url).then(function (response) {
        console.log(response);
        _this.length = response.data.scheduledFlights.length;
      }).catch(function (error) {
        console.log(error);
        _this.errored = true;
      }).finally(function () {
        return _this.loading = false;
      });
    },
    submitpay: function submitpay(numberpayout) {
      if (this.$refs.form.validate()) {
        console.log(numberpayout);
        if (numberpayout == '10000') {
          window.location.href = "https://www.mercadopago.com/mco/checkout/start?pref_id=244974715-8b190980-7260-4575-9f5c-872e824a5bc0";
        }
        if (numberpayout == '20000') {
          window.location.href = "https://www.mercadopago.com/mco/checkout/start?pref_id=244974715-9d789d9c-e316-4c32-a436-71881575835d";
        }if (numberpayout == '50000') {
          window.location.href = "https://www.mercadopago.com/mco/checkout/start?pref_id=244974715-eae31aae-21fb-476f-a81e-7e9c0fe0ae2e";
        }if (numberpayout == '100000') {
          window.location.href = "https://www.mercadopago.com/mco/checkout/start?pref_id=244974715-b4191948-78fc-44ab-9ff4-bd2650c62911";
        }if (numberpayout == '150000') {
          console.log("Hola mundo");
          window.location.href = "https://www.mercadopago.com/mco/checkout/start?pref_id=244974715-e1550ed6-d56b-439a-8868-c6418affbab2";
        }
      }
    },
    formatPrice: function formatPrice(value) {
      var val = (value / 1).toFixed(2).replace('.', ',');
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    },
    clear: function clear() {
      this.name = '';
      this.date = '';
      this.number = '';
      this.today = '';
      this.dialog = '';
      this.checkbox = null;
      this.$validator.reset();
    },
    getPosts: function getPosts() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_3__services_PostsService__["a" /* default */].fetchPosts();

              case 2:
                response = _context.sent;

                _this2.posts = response.data;
                console.log(_this2.posts);

              case 5:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    }
  }
});

/***/ }),
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_Api__ = __webpack_require__(149);


/* harmony default export */ __webpack_exports__["a"] = ({
  fetchPosts: function fetchPosts() {
    return Object(__WEBPACK_IMPORTED_MODULE_0__services_Api__["a" /* default */])().get('posts');
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getImgUrl: function getImgUrl(img) {
      return __webpack_require__(33)("./" + img);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_PostsService__ = __webpack_require__(56);


//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'posts',
  data: function data() {
    return {
      posts: []
    };
  },
  mounted: function mounted() {
    this.getPosts();
  },

  methods: {
    getPosts: function getPosts() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __WEBPACK_IMPORTED_MODULE_2__services_PostsService__["a" /* default */].fetchPosts();

              case 2:
                response = _context.sent;

                _this.posts = response.data;

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vee_validate__ = __webpack_require__(167);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a, { theme: {
    primary: '#2c3e50',
    secondary: '#00b894',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  } });

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_5_axios___default.a;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] },
  template: '<App/>'
});

/***/ }),
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(28);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37a392e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(160);
function injectStyle (ssrContext) {
  __webpack_require__(65)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37a392e8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 65 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 66 */,
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNav_vue__ = __webpack_require__(29);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35712a82_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNav_vue__ = __webpack_require__(69);
function injectStyle (ssrContext) {
  __webpack_require__(68)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TopNav_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35712a82_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_TopNav_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 68 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-toolbar',{staticClass:"white",attrs:{"app":"","fixed":"","scroll-target":"#poliza"}},[_c('v-spacer',{staticClass:"hidden-sm-and-up brand-spacer"}),_vm._v(" "),_c('v-toolbar-title',{staticClass:"text-xs-center brand-logo"},[_c('v-icon',{staticClass:"primary--text brand-icon",attrs:{"x-large":""}},[_vm._v("flight_takeoff")]),_vm._v("FIBCO"),_c('span',{staticClass:"blue--text text--darken-3 hidden-sm-and-down accented-text"},[_vm._v(" Flight Delay Compensation")])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',{staticClass:"hidden-xs-only"},_vm._l((_vm.menu),function(item){return _c('v-btn',{key:item.name,attrs:{"href":item.href,"flat":"","color":"primary"}},[_vm._v(_vm._s(item.name))])}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__ = __webpack_require__(30);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29b84618_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__ = __webpack_require__(72);
function injectStyle (ssrContext) {
  __webpack_require__(71)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MobileMenu_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29b84618_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MobileMenu_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 71 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',[_c('v-layout',{attrs:{"column":"","align-center":"","justify-center":""}},_vm._l((_vm.menu),function(item){return _c('v-list-tile',{key:item.name},[_c('v-list-tile-content',[_c('v-btn',{staticClass:"blue--text text--darken-3 accented-text",attrs:{"href":item.href,"flat":""}},[_vm._v(_vm._s(item.name))])],1)],1)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 73 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/airport.9c7c0fe.jpg";

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/airport2.d40ebed.jpg";

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bhmap.3ad833c.png";

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/blockchain.27f3e3f.png";

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/blockchain2.e7ed22f.png";

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/dam3.697b64a.jpg";

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/fibco.be2aea0.png";

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAAAtCAMAAADcD9SdAAAAAXNSR0IB2cksfwAAAFdQTFRFAAAAKjpPLDxQJzdPHz9PKT1QLD5QLD1QKz1QLD5QKz1PKz1PKzxQKz1QKztPKj1PKz1QKjxQKTxPKz1QKz1PKj1PKz1PKzxPKj1PKzxPKz1PKj1QKz5QG27j2gAAAB10Uk5TADA/IBBPf7/f/8CAn+9AYM+PUK9w0PCgkLDgX29MKpOdAAAENElEQVR4nO2Z2XbjIAyGvdB4X5qmdpLO+z/n2DESQgJDfNI5cxFdNTaC/wMhYZokb/vPLM0sy8kr9XEqirIqi+KUUZcs8/sYy2kTtTOu8notlkqJng7ryrLGdNl29EXb45uq8vlQa2iTYWfcUfm8FqulRG1sdn0g6lN6psdByr0JLA6BLNadlLNDIkqNLsfhMEh13gGp2oMgK0oApHD7qcMgBX9tjTt4vIIgVfWlXB2CqIvHqz8MUvGMYI979niFQaox3wEx2/y7ruvpFSDzLkiXur0iQGiy4IIGaHPd2uTXiYK4XDw2m/Fkwkx6QqLk81py60dp39yMr9liXBU0MrOYHwNRZOIcTQmIlYSDIA9JBgUDkw8Fa2l0J8dAaKDIDGyB0NQVBUJ6H32qSglS2+iRIFZJlUXRAqmuz4IkV3AFoVwV7O6Bd2R0R4HovabHExmYgZjhYkGSu/a8eVRBaJUmbvtm6HsSxlEguqqqm1hgJwg2iAbBrBQAqcofn8YYEK1nhvF4BhYgkISjQTB2ereqgfTd/jgPtzEgZiH0eLwnEIyxrlNXPMjN1sFV0ay5wnydUtZBDIhO2fcEywlvjYIxk45PgkDimj2q5BGla+3pjADR6i/Ln6nuhBVFFKy+YZz2ORAIztqnilRktJbKCIMonXsfXjq9sAxsBCs8BjWvBRFnntVKEmBhEN3Dtuh6iVlRJIJTJBleC5LkszkrgnX+45k0XVW3fKL3C8vAVDAmmCV1vRRkWe5hxtDVZmpaEEQLu+ufN94BBzH7sstfDLK1vMxQPq0ZDYLoT7PitBl8qVkpwxaM+3I8R4PollDaA6pSs/WxpoVAeK0THUiQBNe/iwaBCuSpI8IwgHG3SpcP647GlfYeGne+OxSL5AgQOIOc3apUxtqbJOYH2R5cth+wuaXR2eJ7IbXzSxgEK7dyq1oHKIvrjocESa0HeOgQRjOw2NR2QIZBYH6/PaoG6QSd5x4X0LBlA2V9iNhGiqLMTgNtGQTBYUAGV9X4QRKPC0xOb+mhOQqijWRgR5qlSxkEgVQ4+eJkFk6gYvKC6N29FX9dDG8JNdiY5nzgAEnIpUIAROHlG6rgvzevkTh96Sb+9FuTFYPsbtfxgffhBCGpaxdEnTB8748FWa+69YMWbtb1hJb69K5+8AL1keYy22WzCkCWv/VUdfTWPMs+oJOP9ZJdLS//bL9HuHZ/WI6pC1SvEkfSNPtz+qRXoSlFtVaJ/B4Legt8T9hrbhN/y48CqJFXTDPXmIThUeCCbnC2WkH8RcB902jLcXk8BYIxGAcyuFuRzwGvz2+DQAaMAZkwJF2hNcgTPOHYA5lfAsLS5g7IbBK88xJbNRKlTt2auPsrQLbzYwhkmmmd8v3r7Wwd36dZfh3+Joi674Pc69tFXIh4TfWX5mFn97873/a2t73t39tfCcqWouQbvLkAAAAASUVORK5CYII="

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/plane.599dbd5.jpg";

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/plane2.5962111.jpg";

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/plane3.5130550.jpg";

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/plane3.a896ce0.png";

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/plane4.41ce45f.jpg";

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/plane5.c75766f.jpg";

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/plane6.7067fc6.jpeg";

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/plane7.d3f2a3d.jpg";

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/soilunits.0f88365.png";

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-parallax',{attrs:{"src":_vm.getImgUrl('airport2.jpg'),"height":"600"}},[_c('v-layout',{staticClass:"white--text",attrs:{"column":"","align-center":"","justify-center":""}},[_c('div',{staticClass:"subheading mb-1 hero-text-sub text-xs-center"},[_vm._v("Blockchain | Compensación | Retrasos Aéreos")]),_vm._v(" "),_c('p',{staticClass:"white--text hero-text-header mb-2 display-2 text-xs-center"},[_vm._v("Asegura tu vuelo en caso de un retraso")]),_vm._v(" "),_c('div',{staticClass:"subheading mb-3 hero-text-sub text-xs-center"},[_vm._v("Compra una póliza de "),_c('span',{staticClass:"brand-text"},[_vm._v("FIBCO")]),_vm._v(" y obtiene una compensación "),_c('span',{staticClass:"brand-text"},[_vm._v("rápida, inmediata y flexible")])]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","dark":"","href":"#poliza"}},[_vm._v("\n      Empieza ahora\n    ")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionPolicy_vue__ = __webpack_require__(34);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d42ba96_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionPolicy_vue__ = __webpack_require__(150);
function injectStyle (ssrContext) {
  __webpack_require__(93)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionPolicy_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d42ba96_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionPolicy_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 93 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);


/* harmony default export */ __webpack_exports__["a"] = (function () {
  return __WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({
    baseURL: 'https://fibco.herokuapp.com'
  });
});

/***/ }),
/* 150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"text-xs-center":"","my-2":""}},[_c('v-layout',[_c('v-flex',[_c('h3',{staticClass:"display-1 product-title mt-5"},[_vm._v("Adquiere tu póliza")]),_vm._v(" "),_c('p',{staticClass:"mt-3"},[_vm._v("Ingresa el número y fecha de salida del vuelo que quieres asegurar.")])])],1),_vm._v(" "),_c('div',{staticClass:"px-2"},[_c('form',{staticClass:"mx-2"},[_c('v-dialog',{ref:"dialog",attrs:{"return-value":_vm.date,"data-vv-name":"date","persistent":"","lazy":"","full-width":"","width":"290px"},on:{"update:returnValue":function($event){_vm.date=$event}},model:{value:(_vm.modal),callback:function ($$v) {_vm.modal=$$v},expression:"modal"}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"slot":"activator","error-messages":_vm.errors.collect('date'),"prepend-icon":"event","label":"Fecha de salida","data-vv-name":"date","required":""},slot:"activator",model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"locale":"es-419","min":_vm.today},on:{"input":function($event){_vm.$refs.dialog.save(_vm.date)}},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}})],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:3'),expression:"'required|max:3'"}],attrs:{"counter":3,"mask":"AAA","error-messages":_vm.errors.collect('name'),"label":"Código de aerolínea (Ejemplo: AVA) -> Avianca","prepend-icon":"input","data-vv-name":"name","required":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:4'),expression:"'required|max:4'"}],attrs:{"counter":4,"mask":"####","error-messages":_vm.errors.collect('number'),"label":"Número de vuelo (Ejemplo: 9220)","prepend-icon":"input","data-vv-name":"number","required":""},model:{value:(_vm.number),callback:function ($$v) {_vm.number=$$v},expression:"number"}})],1)],1),_vm._v(" "),_c('v-checkbox',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"error-messages":_vm.errors.collect('checkbox'),"value":"1","label":"Confirmo que tengo el tiquete con el número de vuelo especificado","data-vv-name":"checkbox","type":"checkbox","required":""},model:{value:(_vm.checkbox),callback:function ($$v) {_vm.checkbox=$$v},expression:"checkbox"}}),_vm._v(" "),_c('v-btn',{attrs:{"loading":_vm.dialog,"disabled":_vm.dialog,"color":"primary","dark":""},on:{"click":_vm.submit}},[_vm._v("buscar")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","dark":""},on:{"click":_vm.clear}},[_vm._v("limpiar")])],1),_vm._v(" "),_c('v-dialog',{attrs:{"width":"500","persistent":""},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline white--text justify-center primary",attrs:{"primary":""}},[_c('v-icon',{staticClass:"mr-2 white--text justify-center",attrs:{"medium":""}},[_vm._v("file_copy ")]),_vm._v(" Tu Póliza FIBCO")],1),_vm._v(" "),_c('v-card-text',[(_vm.errored)?_c('section',[_c('p',[_vm._v("En el momento, no podemos obtener la información de su vuelo. Intente más tarde.")])]):_c('section',[(_vm.loading)?_c('div',[_vm._v("Loading...")]):_c('div',[(_vm.length>0)?_c('div',{staticClass:"text-xs-center"},[_vm._v(" Su vuelo "+_vm._s(this.name)+_vm._s(this.number)+" de la fecha "+_vm._s(this.date)+"  está programado\n\n              "),_c('section',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-subheader',[_vm._v("Dinero a pagar")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('v-select',{attrs:{"items":_vm.items,"item-text":"text","item-value":"value","label":"Seleccionar Valor","required":"","single-line":""},model:{value:(_vm.numberpay),callback:function ($$v) {_vm.numberpay=$$v},expression:"numberpay"}})],1)],1),_vm._v("  \n                  Precio a pagar $"+_vm._s(_vm.formatPrice(_vm.numberpay))+"\n\n                   "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.posts,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.time))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v("$"+_vm._s(_vm.formatPrice(_vm.numberpay*props.item.payout)))])]}}])})],1)],1)]):_c('div',{staticClass:"text-xs-center"},[_vm._v(" El vuelo ingresado no existe\n                "),_c('section',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs4":""}},[_c('v-subheader',[_vm._v("Dinero a pagar")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('v-select',{attrs:{"items":_vm.items,"item-text":"text","item-value":"value","label":"Seleccionar Valor","required":"","single-line":""},model:{value:(_vm.numberpay),callback:function ($$v) {_vm.numberpay=$$v},expression:"numberpay"}})],1)],1),_vm._v("  \n\n                  Precio a pagar $"+_vm._s(_vm.formatPrice(_vm.numberpay))+"\n\n                   "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.posts,"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{staticClass:"text-xs-center"},[_vm._v(_vm._s(props.item.time))]),_vm._v(" "),_c('td',{staticClass:"text-xs-center"},[_vm._v("$"+_vm._s(_vm.formatPrice(_vm.numberpay*props.item.payout)))])]}}])})],1)],1)])])])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"text-xs-center":"","disabled":!_vm.valid,"color":"primary"},on:{"click":function($event){_vm.submitpay(_vm.numberpay)}}},[_vm._v("\n                        Pagar\n              ")]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v("\n              Cerrar\n            ")])],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionFeatures_vue__ = __webpack_require__(57);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f08195fa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionFeatures_vue__ = __webpack_require__(153);
function injectStyle (ssrContext) {
  __webpack_require__(152)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionFeatures_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f08195fa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionFeatures_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-md":"","mt-2":""}},[_c('v-divider',{staticClass:"mb-5"}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":"","lg5":"","offset-md1":""}},[_c('h3',{staticClass:"display-1 product-title text-xs-center mt-3"},[_vm._v("¿Por qué FIBCO?")]),_vm._v(" "),_c('p',{staticClass:"mt-4 demo-text primary--text"},[_c('v-icon',{staticClass:"blue--text text--darken-3 demo-icon",attrs:{"left":""}},[_vm._v("done_all")]),_vm._v(" Instantáneo")],1),_vm._v(" "),_c('p',[_vm._v("La compensación ante retrasos de vuelos nunca había sido tan fácil. El contrato inteligente de FIBCO compensa al usuario "),_c('strong',[_vm._v("inmediatamente")]),_vm._v(" un vuelo se encuentra retrasado.")]),_vm._v(" "),_c('p',{staticClass:"mt-4 demo-text primary--text"},[_c('v-icon',{staticClass:"blue--text text--darken-3 demo-icon",attrs:{"left":""}},[_vm._v("autorenew")]),_vm._v(" Automático")],1),_vm._v(" "),_c('p',[_vm._v(" Con FIBCO no debes preocuparte por hacer absolutamente nada, el contrato inteligente "),_c('strong',[_vm._v("por si mismo")]),_vm._v(" se encarga de realizar la compensación. Dile adiós a los largos procesos de compensación.")]),_vm._v(" "),_c('p',{staticClass:"mt-4 demo-text primary--text"},[_c('v-icon',{staticClass:"blue--text text--darken-3 demo-icon",attrs:{"left":""}},[_vm._v("security")]),_vm._v(" Seguro")],1),_vm._v(" "),_c('p',[_vm._v("FIBCO está basado en Blockchain, por lo tanto es practicamente "),_c('strong',[_vm._v("inhackeable")]),_vm._v(", dado que la información de cada póliza se encuentra totalmente "),_c('strong',[_vm._v("distribuida")]),_vm._v(" y "),_c('strong',[_vm._v("descentralizada")]),_vm._v(".")]),_vm._v(" "),_c('p',{staticClass:"mt-4 demo-text primary--text"},[_c('v-icon',{staticClass:"blue--text text--darken-3 demo-icon",attrs:{"left":""}},[_vm._v("attach_money")]),_vm._v(" Flexible")],1),_vm._v(" "),_c('p',[_vm._v("Recibe compensaciones "),_c('strong',[_vm._v("distintas")]),_vm._v(" dependiendo de la póliza que elijas, con tarifas justas y tiempos de retraso variables.")]),_vm._v(" "),_c('v-divider',{staticClass:"hidden-sm-and-up"})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md5":"","lg4":"","offset-md1":"","offset-lg2":"","xl3":""}},[_c('v-card',{staticClass:"blue darken-3",attrs:{"dark":""}},[_c('v-card-text',[_c('v-card',[_c('v-card-media',{attrs:{"src":_vm.getImgUrl('blockchain2.png'),"height":"300"}})],1)],1),_vm._v(" "),_c('v-card-title',{staticClass:"demo-title white--text",attrs:{"primary":""}},[_c('v-icon',{staticClass:"mr-2",attrs:{"x-large":""}},[_vm._v("vpn_lock ")]),_vm._v("  Blockchain")],1),_vm._v(" "),_c('v-card-text',{staticClass:"demo-text"},[_c('p',[_vm._v("Toda póliza adquirida en FIBCO se almacena en una Blockchain")]),_vm._v(" "),_c('p',[_vm._v("La información de las pólizas es inmutable, inhackeable. Una forma descentralizada de asegurarte ante un retraso de vuelo.")])])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionConsulting_vue__ = __webpack_require__(58);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_171b339f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionConsulting_vue__ = __webpack_require__(156);
function injectStyle (ssrContext) {
  __webpack_require__(155)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionConsulting_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_171b339f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionConsulting_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionFooter_vue__ = __webpack_require__(59);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b489a176_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionFooter_vue__ = __webpack_require__(159);
function injectStyle (ssrContext) {
  __webpack_require__(158)
}
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SectionFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b489a176_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SectionFooter_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 158 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"dark":"","height":"auto"}},[_c('v-card',{staticClass:"flex",attrs:{"flat":"","tile":""}},[_c('v-card-title',{staticClass:"blue darken-3"},[_c('strong',{staticClass:"subheading"},[_vm._v("¡Contáctanos en nuestras redes sociales!")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mx-3",attrs:{"dark":"","icon":"","href":"https://github.com/mandresbr/fibco"}},[_c('v-icon',{attrs:{"size":"24px"}},[_vm._v("fab fa-github")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-3",attrs:{"dark":"","icon":"","href":"#"}},[_c('v-icon',{attrs:{"size":"24px"}},[_vm._v("fab fa-twitter")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-3",attrs:{"dark":"","icon":"","href":"https://linkedin.com/in/mandresbr"}},[_c('v-icon',{attrs:{"size":"24px"}},[_vm._v("fab fa-linkedin")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mx-3",attrs:{"dark":"","icon":"","href":"https://instagram.com/fibcodelays"}},[_c('v-icon',{attrs:{"size":"24px"}},[_vm._v("fab fa-instagram")])],1)],1),_vm._v(" "),_c('v-card-actions',{staticClass:"justify-center",attrs:{"color":"primary"}},[_vm._v("\n      ©2018 — "),_c('strong',[_vm._v("FIBCO")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('top-nav',{attrs:{"menu":_vm.menu}}),_vm._v(" "),_c('v-content',[_c('hero'),_vm._v(" "),_c('mobile-menu',{staticClass:"hidden-sm-and-up",attrs:{"menu":_vm.menu}}),_vm._v(" "),_c('policy',{attrs:{"id":"poliza"}}),_vm._v(" "),_c('features',{attrs:{"id":"features"}}),_vm._v(" "),_c('consulting',{attrs:{"id":"consulting"}}),_vm._v(" "),_c('ic-footer',{attrs:{"id":"contact"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Hero__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Posts__ = __webpack_require__(163);





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Hero',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Hero__["a" /* default */]
  }, {
    path: '/posts',
    name: 'Posts',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Posts__["a" /* default */]
  }],
  mode: 'history'
}));

/***/ }),
/* 162 */,
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Posts_vue__ = __webpack_require__(60);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d97bff9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Posts_vue__ = __webpack_require__(164);
var normalizeComponent = __webpack_require__(3)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Posts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6d97bff9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Posts_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"posts"},[_c('h1',[_vm._v("Posts")]),_vm._v("\n  This file will list all the posts.\n\n  "),_vm._l((_vm.posts),function(post){return _c('div',[_c('p',[_c('span',[_c('b',[_vm._v(_vm._s(post.random))])]),_c('br')])])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 165 */,
/* 166 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
]),[61]);


// WEBPACK FOOTER //
// static/js/app.1358239e49cc6de636e1.js